<div>
  <div class="p-b-10 flex flex-horiz-space-bw">
    <div></div>
    <!-- <Icon type="reload"></Icon> -->
    <div>
      <!-- <button nz-button nzType="default" (click)="refreshCorrespondence()"> <i nz-icon nzType="reload"></i>
        Refresh</button> -->
      <span style="padding:0 5px"></span>
      <button id="correspondenceButtonId" nz-button nzType="primary" (click)="resetAllFields();openCorrModal()">New Correspondence</button>
    </div>
  </div>

  <nz-timeline *ngIf="acknowledgementFlag && !counterFl">
    <nz-timeline-item nzColor="green" *ngFor="let item of corList">
      <h4 class="f-w-600">{{item.channelCd}}
        <span *ngIf="item.statusCd === 'PENDING'">
          <nz-tag [nzColor]="'orange'">Pending</nz-tag>
        </span>
        <span *ngIf="item.statusCd === 'VERIFIED'">
          <nz-tag [nzColor]="'green'">Verified</nz-tag>
        </span>
        <span *ngIf="item.statusCd === 'DISPATCHED'">
          <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
        </span>

        <!-- <span>
          <nz-tag>{{(item?.statusCd | technicalTranslate : 'corresStatusCd') || ''}}</nz-tag>
      </span> -->

      </h4>
      <p><i class="anticon anticon-calendar"></i>{{getDateString(item?.createdDt)}}</p>
      <p>
        <span *ngIf="item.receipent != null"> To: {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
          <br></span>
        <span *ngIf="item.templateDesc != null">
          <a (click)="fetchMessageByGuid(item)">
            Message: {{item?.templateDesc}}
          </a>
        </span> <br>
        <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
        <span *ngIf="item.clientRefGuid != null"></span>
        <br>

      </p>
    </nz-timeline-item>
    <!-- <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your claim is being processed
        </p>
      </nz-timeline-item> -->
  </nz-timeline>
  <nz-timeline *ngIf="!acknowledgementFlag">
    <nz-timeline-item nzColor="green">
      <h4 class="f-w-600">LETTER
        <!-- <span *ngIf="item.statusCd === 'PENDING'">
          <nz-tag [nzColor]="'orange'">Pending</nz-tag>
        </span> -->
        <span>
          <nz-tag [nzColor]="'green'">Verified</nz-tag>
        </span>
        <!-- <span *ngIf="item.statusCd === 'DISPATCHED'">
          <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
        </span> -->

        <!-- <span>
          <nz-tag>{{(item?.statusCd | technicalTranslate : 'corresStatusCd') || ''}}</nz-tag>
      </span> -->

      </h4>
      <!-- <p><i class="anticon anticon-calendar"></i>{{getDateString(item?.createdDt)}}</p> -->
      <p>
        <!-- <span *ngIf="item.receipent != null"> To: {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
          <br></span> -->
        <span>
          <a>
            Message: Acknowledgement Pending Counter Offer
          </a>
        </span> <br>
        <!-- <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
        <span *ngIf="item.clientRefGuid != null"></span> -->
        <br>

      </p>
    </nz-timeline-item>
    <!-- <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your claim is being processed
        </p>
      </nz-timeline-item> -->
  </nz-timeline>

  <nz-timeline *ngIf="counterFl">
    <nz-timeline-item nzColor="green">
      <div>
        <h4 class="f-w-600">LETTER
        <!-- <span *ngIf="item.statusCd === 'PENDING'">
          <nz-tag [nzColor]="'orange'">Pending</nz-tag>
        </span> -->
        <span>
          <nz-tag [nzColor]="'green'">Verified</nz-tag>
        </span>
        <!-- <span *ngIf="item.statusCd === 'DISPATCHED'">
          <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
        </span> -->

        <!-- <span>
          <nz-tag>{{(item?.statusCd | technicalTranslate : 'corresStatusCd') || ''}}</nz-tag>
      </span> -->

      </h4>
      <!-- <p><i class="anticon anticon-calendar"></i>{{getDateString(item?.createdDt)}}</p> -->
      <p>
        <!-- <span *ngIf="item.receipent != null"> To: {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
          <br></span> -->
          
        <span>
          <a>
            Message: Acknowledgement
          </a>
        </span> <br>
        <!-- <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
        <span *ngIf="item.clientRefGuid != null"></span> -->
        <br>

      </p></div>
      <div>
        <h4 class="f-w-600">LETTER
        <!-- <span *ngIf="item.statusCd === 'PENDING'">
          <nz-tag [nzColor]="'orange'">Pending</nz-tag>
        </span> -->
        <span>
          <nz-tag [nzColor]="'green'">Verified</nz-tag>
        </span>
        <!-- <span *ngIf="item.statusCd === 'DISPATCHED'">
          <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
        </span> -->

        <!-- <span>
          <nz-tag>{{(item?.statusCd | technicalTranslate : 'corresStatusCd') || ''}}</nz-tag>
      </span> -->

      </h4>
      <!-- <p><i class="anticon anticon-calendar"></i>{{getDateString(item?.createdDt)}}</p> -->
      <p>
        <!-- <span *ngIf="item.receipent != null"> To: {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
          <br></span> -->
          
        <span>
          <a>
            Message: Pending Counter Offer
          </a>
        </span> <br>
        <!-- <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
        <span *ngIf="item.clientRefGuid != null"></span> -->
        <br>

      </p></div>
      
    </nz-timeline-item>
    <!-- <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your claim is being processed
        </p>
      </nz-timeline-item> -->
  </nz-timeline>
</div>



<!-- New correspondence  [nzFooter]="showFooter" -->
<!-- <nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence" (nzOnCancel)="modalCorrespNew=false"
  (nzOnOk)="saveCorrespondence()" [nzOkText]="modalBtnText" [nzFooter]="modalFooter" nzWidth="75%" nzZIndex="1400"> -->
<nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="Correspondence" [nzContent]="modalContent" [nzFooter]="modalFooter" nzWidth="90%"
  (nzOnCancel)="modalCorrespNew=false">
  <ng-template #modalContent>
    <div *ngIf="modalCorrespNew" [ngClass]="{'inputs-are-disabled': corsEditMode}">
      <nz-radio-group [(ngModel)]="correspondenceDO.channelCd" [nzButtonStyle]="'solid'" [nzSize]="'default'"
        (ngModelChange)="modelChanged($event)">
        <label nz-radio-button nzValue="EMAIL"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
        <label nz-radio-button nzValue="SMS"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
        <label nz-radio-button nzValue="PDF"><i nz-icon nzType="file-pdf" nzTheme="outline"></i>Letters</label>
      </nz-radio-group>

      <div *ngIf="'EMAIL'==correspondenceDO.channelCd  || 'LETTER' == correspondenceDO.channelCd">

        <h4 class="d-b m-t-20">To</h4>
        <!-- Multi emails; ENTER to add new entry  nzMode="tags"
nzMode="tags"
nzMode="tags"
nzMode="tags"-->
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.recipient">
          <nz-option *ngFor="let item of emailList" [nzLabel]="item" [nzValue]="item"></nz-option>
        </nz-select>
        <!-- <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceDO.receipent"> -->

        <h4 class="d-b m-t-20">CC</h4>
        <!-- Multi emails; ENTER to add new entry -->
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.cc">
          <nz-option *ngFor="let item of emailList" [nzLabel]="item" [nzValue]="item"></nz-option>
        </nz-select>

        <h4 class="d-b m-t-20">BCC</h4>
        <!-- Multi emails; ENTER to add new entry -->
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.bcc">
          <nz-option *ngFor="let item of emailList" [nzLabel]="item" [nzValue]="item"></nz-option>
        </nz-select>

        <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
          <div class="flexie-auto-grid">
            <div>
              <small class="d-b text-a-left col-dark">Select replacement</small>
              <nz-select style="width:180px" [(ngModel)]="replacementSelected"
                (ngModelChange)="replacementSelect(replacementSelected)">
                <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
              </nz-select>
            </div>
            <div style="width:180px">
              <small class="d-b text-a-left col-dark">Copy-paste code</small>
              <!-- One-way bound ! -->
              <input type="text" nz-input [ngModel]="replacementSelectedKaValue" name="replacement" #selectionInput
                (click)="selectionInput.select()" />
            </div>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Template</small>
            <nz-select style="width:600px" [(ngModel)]="templateType" (ngModelChange)="modeltemplateChange($event)">
              <!-- <nz-option *ngFor="let i of templateArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option> -->
              <nz-option *ngFor="let item of (lookup$.cor_Templates | async) as templateLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </div>
        </div>

        <h4 class="d-b">Subject</h4>
        <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceDO.subject">


        <nz-tabset>
          <nz-tab [nzTitle]="'Email Content'">
            <angular-editor id="editEmail" [(ngModel)]="correspondenceMsgDO.body"></angular-editor>
          </nz-tab>
          <nz-tab [nzTitle]="'Attachment Content'">
            <angular-editor id="editEmail" [(ngModel)]="correspondenceMsgDO.message"></angular-editor>
          </nz-tab>
        </nz-tabset>
      </div>

      <div *ngIf="'PDF'==correspondenceDO.channelCd">
        <h4 class="d-b m-t-20">Content</h4>
        <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
          <div class="flexie-auto-grid">
            <div>
              <small class="d-b text-a-left col-dark">Select replacement</small>
              <nz-select style="width:180px" [(ngModel)]="replacementSelected"
                (ngModelChange)="replacementSelect(replacementSelected)">
                <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
              </nz-select>
            </div>
            <div style="width: 180px;">
              <small class="d-b text-a-left col-dark">Copy-paste code</small>
              <!-- One-way bound ! -->
              <input type="text" nz-input [ngModel]="replacementSelectedKaValue" name="replacement" #selectionInput
                (click)="selectionInput.select()" />
            </div>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Template</small>
            <nz-select style="width: 600Px;" [(ngModel)]="templateType" (ngModelChange)="modeltemplateChange($event)">
              <nz-option *ngFor="let item of (lookup$.cor_Templates | async) as templateLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </div>
        </div>
        <angular-editor [(ngModel)]="correspondenceMsgDO.message"></angular-editor>
      </div>

      <div *ngIf="'SMS'==correspondenceDO.channelCd">
        <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
        <!-- Multi phone nos; ENTER to add new entry -->
        <nz-select style="width: 100%;" [(ngModel)]="correspondenceMsgDO.recipient">
          <nz-option *ngFor="let item of mobList" [nzLabel]="item" [nzValue]="item"></nz-option>
        </nz-select>
        <h4 class="d-b m-t-20">Message</h4>
        <textarea nz-input [(ngModel)]="correspondenceMsgDO.message"></textarea>
      </div>

    </div>
  </ng-template>
  <!-- (nzOnCancel)="modalCorrespNew=false"
  (nzOnOk)="saveCorrespondence()" -->
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="cancelCorres()">Close</button>
    <button nz-button nzType="default" (click)="showPdfPreview('Download')"
      [nzLoading]="downloadInProgress">Download</button>
    <button nz-button nzType="default" (click)="showPdfPreview('Preview')"
      [nzLoading]="previInProgress">Preview</button>
    <!-- <button nz-button nzType="default" (click)="showPreview()">Preview</button> -->
    <button *ngIf="showFooter" nz-button nzType="default" (click)="verifyCorres()">Verify</button>
    <button *ngIf="showFooter" nz-button nzType="primary" (click)="saveCorrespondence()"
      [nzLoading]="isConfirmLoading">Save</button>
  </ng-template>
</nz-modal>



<nz-modal [(nzVisible)]="modalPreview" nzTitle="Report Preview" (nzOnCancel)="modalPreview=false"
  (nzOnOk)="modalPreview=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
    <div *ngIf="modalPreview">
      <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block; min-width:640px">
      </pdf-viewer>
    </div>
  </ng-container>
</nz-modal>


<nz-modal nzTitle="Preview" [nzVisible]="modalPDFpreview" [nzStyle]="{ top: '0px', width: '100vw', height: '100vh' }"
  [nzBodyStyle]="{ height: 'calc(100vh - 55px)', overflow: 'hidden' }" [nzWidth]="'100%'" [nzFooter]="null"
  (nzOnCancel)="modalPDFpreview=false" (nzOnOk)="modalPDFpreview=false">
  <!-- <div class="grid grid-gap-10 grid-2x grid-2x-responsive">
    <div>
      <span class="text-a-center d-b"><h6>Preview</h6></span>
      <div style="height: 80vh; overflow-y: scroll; max-width: 50%">
        <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block;">
        </pdf-viewer>
      </div>
    </div>
    <div>
      <span class="text-a-center d-b"><h6>Worksheet</h6></span>
      <div style="height: 80vh; overflow-y: scroll; ; max-width: 50%">
        <app-ui-worksheet [IO]="_IO" transactionState="transactionState"></app-ui-worksheet>
      </div>
    </div>
  </div> -->
  <ng-container *nzModalContent>
    <div style="height: 80vh; overflow-y: scroll; max-width: 100%">
      <nz-tabset>
        <nz-tab nzTitle="PDF Preview">
          <pdf-viewer [src]="previewDataStream" [render-text]="false" style="display: block;">
          </pdf-viewer>
        </nz-tab>
        <!-- Worksheet has been commented because when we shifted correspondence to Product, 
      we found UIWorksheet to be too Claim Specific -->
        <!-- ------------ -->
        <!-- <nz-tab nzTitle="Worksheet">
        <app-ui-worksheet [IO]="_IO" transactionState="transactionState" style="width:100%"></app-ui-worksheet>
      </nz-tab> -->
      </nz-tabset>

    </div>
  </ng-container>
</nz-modal>